const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/user-management/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/user-management')({
  beforeLoad: requireCapabilities(has => has('users.list') || has('authz.permission-sets.list') || has('organization-members.list') && has('organizations.list')),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});